import { render, staticRenderFns } from "./UserFamilyItemChild.vue?vue&type=template&id=0ec39d11&scoped=true&"
import script from "./UserFamilyItemChild.vue?vue&type=script&lang=js&"
export * from "./UserFamilyItemChild.vue?vue&type=script&lang=js&"
import style0 from "./UserFamilyItemChild.vue?vue&type=style&index=0&id=0ec39d11&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec39d11",
  null
  
)

export default component.exports